import React from 'react';
import './blog3Hernia.css'; 

const HerniaBlog = () => {
  return (
    <div className="hernia-blog-container">
      <h1>Hernia Myths Busted: Why Ignoring That Bulge May Cost You Your Health</h1>
      <p className="hernia-subheading">A Surgical Awareness Blog from Sukam Speciality Clinic’s General Surgery Division</p>

      <section>
        <h2>🎯 Introduction: The Bulge That Speaks Volumes — But Are You Listening?</h2>
        <p>
          A small bulge in your groin, a puff near your belly button, or a lump that appears while coughing — often brushed off. 
          Many believe: “It’s not painful.” or “It’ll go away.” 
          But hernias don’t disappear. They grow, silently becoming dangerous.
        </p>
        <p>
          At Sukam Speciality Clinic, we've seen how delay due to fear or myths turns minor hernias into surgical emergencies. 
          This guide busts those myths and walks you through warning signs, treatment, and modern solutions.
        </p>
      </section>

      <section>
        <h2>📘 What Exactly is a Hernia?</h2>
        <p>
          A hernia occurs when tissue (like intestine or fat) pushes through a weak spot in the muscle wall. 
          It appears as a bulge, which might go away when lying down but still needs evaluation.
        </p>
        <ul>
          <li>Appears with coughing, straining, standing or lifting</li>
          <li>May reduce on lying down but won’t disappear permanently</li>
        </ul>
      </section>

      <section>
        <h2>🧩 Common Types of Hernia</h2>
        <ul>
          <li><strong>Inguinal:</strong> Groin — common in men, lifters</li>
          <li><strong>Umbilical:</strong> Belly button — infants, pregnant women</li>
          <li><strong>Femoral:</strong> Below groin — elderly women, high strangulation risk</li>
          <li><strong>Hiatal:</strong> Inside chest — causes reflux, common in obese</li>
          <li><strong>Incisional:</strong> Scar hernias — after surgery</li>
          <li><strong>Spigelian/Epigastric:</strong> Lateral or upper abdomen</li>
        </ul>
      </section>

      <section>
        <h2>❌ Hernia Myths vs Facts</h2>
        <table>
          <thead>
            <tr><th>Myth</th><th>Reality</th></tr>
          </thead>
          <tbody>
            <tr><td>“No pain = not serious”</td><td>Many hernias are painless but risky</td></tr>
            <tr><td>“Only old men get hernias”</td><td>Women, children, athletes — anyone can</td></tr>
            <tr><td>“I can push it back”</td><td>That doesn’t mean it’s harmless — it may trap anytime</td></tr>
            <tr><td>“Belts/yoga will fix it”</td><td>Temporary relief, not a cure. Only surgery is definitive</td></tr>
            <tr><td>“Surgery is painful”</td><td>Modern laparoscopy is fast, low-pain, minimal scar</td></tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>⚠️ Hernia Emergencies</h2>
        <ul>
          <li><strong>Incarceration:</strong> Trapped tissue → pain, vomiting</li>
          <li><strong>Strangulation:</strong> Blood supply cut → tissue death → sepsis</li>
          <li><strong>Obstruction:</strong> Intestinal block → bloating, constipation</li>
        </ul>
        <p><em>These are life-threatening and need urgent surgery.</em></p>
      </section>

      <section>
        <h2>🩺 How We Diagnose at Sukam</h2>
        <ul>
          <li>✅ Detailed physical exam by our surgeons</li>
          <li>✅ Ultrasound or CT scan if needed</li>
          <li>✅ Laparoscopy for hidden/internal hernias</li>
          <li>✅ Pre-op medical clearance for fitness</li>
        </ul>
      </section>

      <section>
        <h2>🛠️ Surgical Solutions We Offer</h2>
        <ul>
          <li><strong>Laparoscopic Repair:</strong> 3 tiny cuts, mesh repair, fast recovery</li>
          <li><strong>Open Repair:</strong> For large/complex hernias</li>
          <li><strong>Robotic Surgery:</strong> For precision in select referral cases</li>
        </ul>
      </section>

      <section>
        <h2>⏳ Recovery Timeline</h2>
        <table>
          <thead>
            <tr><th>Milestone</th><th>Expected Timeline</th></tr>
          </thead>
          <tbody>
            <tr><td>Walking</td><td>Same or next day</td></tr>
            <tr><td>Discharge</td><td>24–48 hours</td></tr>
            <tr><td>Desk job</td><td>3–5 days</td></tr>
            <tr><td>Light work</td><td>After 1 week</td></tr>
            <tr><td>Heavy lifting</td><td>4–6 weeks</td></tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>📋 Post-Op Care at Sukam</h2>
        <ul>
          <li>✅ Tailored advice based on your job and lifestyle</li>
          <li>✅ Diet, stool softeners to avoid strain</li>
          <li>✅ Abdominal support binder if needed</li>
          <li>✅ 24/7 WhatsApp and phone support</li>
        </ul>
      </section>

      <section>
        <h2>🗣️ Real Patient Stories</h2>
        <p><strong>Suresh, 47:</strong> “Thought it was fat — turned out to be an inguinal hernia. Surgery next morning. Back to work in 4 days.”</p>
        <p><strong>Leela, 59:</strong> “Feared surgery for 3 years. Did laparoscopy — just 2 days stay. I lift my grandchild happily now.”</p>
      </section>

      <section>
        <h2>🔔 Final Words: Act Early, Stay Safe</h2>
        <p>
          Hernias are not cosmetic — they are progressive defects. They don’t go away. 
          With early treatment, they are fixed in a day. With delay, they can turn dangerous.
        </p>
        <p className="cta">
          ✅ Book a comprehensive hernia screening at Sukam Speciality Clinic today.  
          We help you get back to life — pain-free and confidently!
        </p>
      </section>
    </div>
  );
};

export default HerniaBlog;
